let { useEffect } = require('react');

function useSeo ({title, ...props}) {
  useEffect(() => {
    document.title = title ? title : process.env.MIX_APP_NAME;
  }, [title]);
}

export default useSeo;
